import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { FeatureSwitcherComponentController } from "./FeatureSwitcherComponentController";

export class FeatureFlagComponent implements IComponentOptions {
    public transclude = true;

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public bindings = {
        feature: "@",
        reverse: "<",
    };

    public template = `<ng-transclude ng-if="$ctrl.showFeature"></ng-transclude>`;

    constructor() {
        this.controller = FeatureSwitcherComponentController;
    }
}
